import { EntityTypeCode, useFetchCallType, useViewerEntity } from '@rahtab/auth/lib/token-based-auth';
import { useState } from 'react';

function useOrdersHistory({ merchandiseId }: { merchandiseId: string }) {
  const { viewerSelectedEntity } = useViewerEntity();
  const [orderIds, setOrderIds] = useState<Set<string>>(new Set());
  const [orders, setOrders] = useState<{ [orderId: string]: Order }>({});
  const [_, setRefetching] = useState(false);
  const [refetch, { data, loading, called, fetchMore }] = useFetchCallType<GetTemplateHistoryResult>(
    'GetTemplateRequestHistory',
    {
      params: `TemplateCode=${merchandiseId}&Length=20`,
      onCompleted: (result) => {
        setRefetching((_isRefetching) => {
          const fetchedOrders: { [orderId: string]: Order } = {};
          const parsedOrders = result.data.map(getOfferListResultReducer(viewerSelectedEntity?.typeCode));
          parsedOrders.forEach((order) => {
            fetchedOrders[order.orderId] = order;
          });
          if (_isRefetching) {
            setOrders(fetchedOrders);
            // setOrders(result.data.map(getOfferListResultReducer(viewerSelectedEntity?.typeCode)));
          } else {
            setOrders((v) => ({
              ...v,
              ...fetchedOrders,
              // ...(v || []),
              // ...result.data.map(getOfferListResultReducer(viewerSelectedEntity?.typeCode)),
            }));
          }
          return false;
        });
      },
    },
  );
  return {
    data: {
      data: Object.values(orders),
      rateCount: data?.commentCount,
      notReceivedCount: data?.notReceiveCount,
      orderCount: data?.requestCount,
    },
    loading,
    called,
    refetch: () => {
      setRefetching(true);
      refetch({ params: `TemplateCode=${merchandiseId}&Length=20` });
    },
    fetchMore: () => {
      if (!data || data.data.length < 20 || !called || loading) return;
      fetchMore({ params: `TemplateCode=${merchandiseId}&Length=20&Start=${Object.keys(orders).length}` });
    },
  };
}
function getOfferListResultReducer(
  entityTypeCode: EntityTypeCode = EntityTypeCode.Provider,
): (data: OrderTemplate) => Order {
  return (data) => {
    const {
      RequestIdentification: orderId,
      AssignFinallCode: assignFinalCode,
      AssignPrimaryCode: assignPrimaryCode,
      SupplierName: supplierName,
      TemplateName: merchandiseName,
      ReqAmount: orderCount,
      PriceTotal: totalPrice,
      DeliveryDate: deliveryDate,
      ReqDate: orderDate,
      Status: status,
      StatusCode: statusCode,
      MeasureName: measureUnit,
      RequestCode: orderCode,
      ReqMaxAmount: maxOrderAmount,
      SetReqMaxAmountAccess,
    } = data;

    return {
      orderId,
      assignFinalCode: entityTypeCode === EntityTypeCode.Provider ? assignFinalCode : assignPrimaryCode,
      supplierName,
      merchandiseName,
      orderCount,
      totalPrice,
      deliveryDate,
      orderDate,
      status,
      statusCode,
      measureUnit,
      orderCode,
      maxOrderAmount,
      viewerCanSetMaxOrderAmount: SetReqMaxAmountAccess || false,
    };
  };
}
export default useOrdersHistory;
export interface Order {
  orderId: string;
  orderCode: string;
  assignFinalCode: string;
  supplierName: string;
  merchandiseName: string;
  orderCount: string;
  totalPrice: string;
  deliveryDate: string;
  orderDate: string;
  status: string;
  statusCode: '1' | '2' | '3';
  measureUnit: string;
  maxOrderAmount: string;
  viewerCanSetMaxOrderAmount: boolean;
}

interface GetTemplateHistoryResult {
  data: OrderTemplate[];
  commentCount: string;
  notReceiveCount: string;
  requestCount: string;
}

interface OrderTemplate {
  row: string;
  RequestCode: string;
  EnRequestCode: string;
  RequestIdentification: string; // شناسه سفارش
  ReqAmount: string; // مقدار سفارش
  ReqAmountStr: string; //مقدار سفارش تفکیک شده سه رقمی
  MeasureName: string; //واحد مقدار
  MeasureCode: string;
  PricePerUnit: string; //قیمت واحد
  PricePerUnitStr: string; // قیمت واحد تفکیک شده سه رقمی
  PriceTotal: string;
  PriceTotalStr: string;
  CheckoutType: string;
  ReqDate: string; // تاریخ سفارش
  TemplateName: string;
  SupplierName: string; // فروشنده
  Status: string;
  StatusCode: '1' | '2' | '3';
  OtherSupplierName: string;
  ItemWeight: string;
  DeliveryDate: string;
  ItemCount: string;
  DeliveryLocation: string;
  AssignFinallCode: string;
  AssignPrimaryCode: string;
  ReqMaxAmount: string;
  SetReqMaxAmountAccess?: boolean;
}
